import * as ls from 'local-storage'
import { RegisterUser } from '../types/default-types'

import {
  fetchPrivateAPIToken,
  withPrivateAPIToken,
  withPublicAPIToken,
  apiFetchData,
  signout as signoutService,
} from './service'

const { REACT_APP_DATA_TOKEN } = process.env

const toFormData = (props: any): FormData => {
  const data = new FormData()
  Object.keys(props).forEach((key) => {
    if (typeof props[key] !== 'undefined') {
      data.append(key, props[key])
    }
  })
  return data
}

export const constants = async () =>
  withPublicAPIToken({
    url: '/public/const',
    method: 'get',
  })

export const authSession = async (data: { uuid: string }) =>
  apiFetchData({
    url: '/public/session/auth',
    method: 'post',
    data: { ...data },
  })

export const auth = async () =>
  withPrivateAPIToken({
    url: '/private/user',
    method: 'get',
  })

export const getDataAll = async () =>
  withPublicAPIToken({
    url: '/public/data/all',
    method: 'get',
  })

export const getAccess = async () =>
  withPublicAPIToken({
    url: '/public/data/access',
    method: 'get',
  })

export const getNews = async () =>
  withPrivateAPIToken({
    url: '/private/news/get',
    method: 'get',
  })

export const getTourAll = async (props: { data: any; page: number; perPage: number }) =>
  await withPrivateAPIToken({
    url: `/private/tour/1?page=${props.page}&perPage=${props.perPage}`,
    method: 'post',
    data: { ...props.data },
  })
    .then((res) => {
      return res
    })
    .catch(() => {
      return { data: [] }
    })

export const getTourAllV2 = async (props: { data: any; page: number; perPage: number }) =>
  await withPrivateAPIToken({
    url: `/private/tour/2?page=${props.page}&perPage=${props.perPage}`,
    method: 'post',
    data: { ...props.data },
  })
    .then((res) => {
      return res
    })
    .catch(() => {
      return { data: [] }
    })

export const getTourAllV3 = async (props: { data: any; page: number; perPage: number }) =>
  await withPrivateAPIToken({
    url: `/private/tour/3?page=${props.page}&perPage=${props.perPage}`,
    method: 'post',
    data: { ...props.data },
  })
    .then((res) => {
      return res
    })
    .catch(() => {
      return { data: [] }
    })

export const getTourAllV4 = async (props: { data: any; page: number; perPage: number }) =>
  await withPrivateAPIToken({
    url: `/private/tour/4?page=${props.page}&perPage=${props.perPage}`,
    method: 'post',
    data: { ...props.data },
  })
    .then((res) => {
      return res
    })
    .catch(() => {
      return { data: [] }
    })

export const getTourNomination = async () =>
  withPrivateAPIToken({
    url: '/private/tour/nomination',
    method: 'get',
  })

export const getTourRegion = async () =>
  withPrivateAPIToken({
    url: '/private/tour/region',
    method: 'get',
  })

export const getTourSubdivision = async (region?: string) =>
  withPrivateAPIToken({
    url: `/private/tour/subdivision${region ? `?region=${region}` : ''}`,
    method: 'get',
  })

export const getTourTU = async () =>
  withPrivateAPIToken({
    url: '/private/tour/tu',
    method: 'get',
  })

export const getTourMM = async () =>
  withPrivateAPIToken({
    url: '/private/tour/mm',
    method: 'get',
  })

export const getMap = async () =>
  withPrivateAPIToken({
    url: '/private/map',
    method: 'get',
  })

export const signin = async (username: string, password: string) => fetchPrivateAPIToken(username, password)
export const logout = async () => signoutService()

export const forgotPassword = async (data: { recaptcha: any; email: string }) => {
  return withPublicAPIToken({
    url: '/public/forgot/link',
    method: 'post',
    data,
  })
}

export const forgotPasswordChange = (data: { code: string; password: string; recaptcha: string }) =>
  withPublicAPIToken({
    url: `/public/forgot/change/${data.code}`,
    method: 'post',
    data: { ...data },
  })

export const preSignup = async (data: { login: string; position_id: number; recaptcha: string }) => {
  return await withPublicAPIToken({
    url: '/public/register/pre',
    method: 'post',
    data: { ...data },
  })
}

export const signup = async (data: RegisterUser) => {
  return await withPublicAPIToken({
    url: '/public/register/do',
    method: 'post',
    data: { ...data },
  })
}

export const lkInfo = async () =>
  withPrivateAPIToken({
    url: '/private/profile',
    method: 'get',
  })

export const getMaterials = async () =>
  withPrivateAPIToken({
    url: '/private/materials/get',
    method: 'get',
  })

export const resendEmail = async (data: { email: string; recaptcha: string }) =>
  withPrivateAPIToken({
    url: '/public/private/confirm/resend/email',
    method: 'post',
    data: { ...data },
  })

export const getRequestList = async () =>
  withPublicAPIToken({
    url: '/public/data/nomination',
    method: 'get',
  })

export const requestRegister = async (data: { nominationId: number }) =>
  withPrivateAPIToken({
    url: '/private/request/create',
    method: 'post',
    data: { ...data },
  })

export const requestModer = async (data: { requestId: number; status: string }) =>
  withPrivateAPIToken({
    url: '/private/request/moder',
    method: 'post',
    data: { ...data },
  })

export const confirmEmail = (data: { code: string }) =>
  withPublicAPIToken({
    url: `/public/register/confirm/email/${data.code}`,
    method: 'post',
    data: { ...data },
  })

export const getCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/get',
    method: 'post',
    data: { ...data },
  })

export const showCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/show',
    method: 'post',
    data: { ...data },
  })

export const startCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/start',
    method: 'post',
    data: { ...data },
  })

export const saveCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/save',
    method: 'post',
    data: { ...data },
  })

export const subcatCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/subcat',
    method: 'post',
    data: { ...data },
  })

export const finishCheckList = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/finish',
    method: 'post',
    data: { ...data },
  })

export const moderCheckList = async (data: { requestId: number; status: string }) =>
  withPrivateAPIToken({
    url: '/private/request/final',
    method: 'post',
    data: { ...data },
  })

export const getCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/get',
    method: 'post',
    data: { ...data },
  })

export const startCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/start',
    method: 'post',
    data: { ...data },
  })

export const saveCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/save',
    method: 'post',
    data: { ...data },
  })

export const showCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/show',
    method: 'post',
    data: { ...data },
  })

export const subcatCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/subcat',
    method: 'post',
    data: { ...data },
  })

export const finishCheckListV2 = async (data: any) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/finish',
    method: 'post',
    data: { ...data },
  })

export const moderCheckListV2 = async (data: { request_id: number; status: string }) =>
  withPrivateAPIToken({
    url: '/private/checklist/v2/moder',
    method: 'post',
    data: { ...data },
  })

export const getSubscribe = async () =>
  withPrivateAPIToken({
    url: '/private/subscribe/get',
    method: 'get',
  })

export const readSubscribe = async (data: { subscribeId: number }) =>
  withPrivateAPIToken({
    url: '/private/subscribe/read',
    method: 'post',
    data: { ...data },
  })

export const getQuizMediaCup = async () =>
  withPrivateAPIToken({
    url: '/private/quiz/get',
    method: 'get',
  })

export const quizMediaCup = async (data: { id: number; answer_num: number }) =>
  withPrivateAPIToken({
    url: '/private/quiz/set',
    method: 'post',
    data: { ...data },
  })

export const getQuizTestMediaCup = async () =>
  withPrivateAPIToken({
    url: '/private/quiz/test/get',
    method: 'get',
  })

export const quizMediaTestCup = async (data: { answer: any; time_left: boolean }) =>
  withPrivateAPIToken({
    url: '/private/quiz/test/set',
    method: 'post',
    data: { ...data },
  })

export const getMediaCupList = async () =>
  withPrivateAPIToken({
    url: '/private/media/cup',
    method: 'get',
  })

export const votedMediaCup = async (data: { id: number }) =>
  withPrivateAPIToken({
    url: '/private/media/cup/vote',
    method: 'post',
    data: { ...data },
  })

export const getMediaMarketList = async () =>
  withPrivateAPIToken({
    url: '/private/media/market',
    method: 'get',
  })

export const getMediaMarket = async (data: { id: number }) =>
  withPrivateAPIToken({
    url: `/private/media/market/${data.id}`,
    method: 'get',
  })

export const votedMediaMarket = async (data: { id: number }) =>
  withPrivateAPIToken({
    url: '/private/media/market/vote',
    method: 'post',
    data: { ...data },
  })

export const post = async (url: string, data: any) =>
  withPrivateAPIToken({
    url,
    method: 'post',
    data,
  })

export const get = async (url: string, params?: any) =>
  withPublicAPIToken({
    url,
    method: 'get',
    params,
  })
